// performance
export const SHOW_STATS = false; // dev stats...
export const FPS = 30; // frames per sec
// global timing
export const HIDE_PLAYGROUND_TIME = 3000; // ms
// Backgdound sounds
export const BG_PAN_MIN = .05;
export const BG_PAN_MAX = .85;
export const BG_VOL_MIN = .2;
export const BG_VOL_MAX = .4;
export const BG_LAYER_3_PROB = .8;
export const BG_LAYER_3_VOL_MIN = .03;
export const BG_LAYER_3_VOL_MAX = .07;
// Accent sounds
export const ACCENT_POT_SIZE_MIN = 4; // min no of accent sounds in 1 comp
export const ACCENT_POT_SIZE_MAX = 12; // max no of accent sounds in 1 comp
export const ACCENT_VOL_MIN = .5;
export const ACCENT_VOL_MAX = .9;
export const ACCENT_PAN_MIN = -.9;
export const ACCENT_PAN_MAX = .9;
export const ACCENT_PAUSE_MIN = 500; // accent pause time min

// export const ACCENT_PAUSE_MAX = 1000; // tmp  for TESTING
export const ACCENT_PAUSE_MAX = 6000; // aceent pause time max
// export const ACCENT_LAYERS_MIN = 1; // tmp  for TESTING
export const ACCENT_LAYERS_MIN = 2; // min number of layers
// export const ACCENT_LAYERS_MAX = 1; // tmp  for TESTING
export const ACCENT_LAYERS_MAX = 5; // max number of layers


// shapes model (lines vs points)
export const SHAPES_POINTS_CHANCE = 30; // % chance the composition has points
// shapes amount
export const MIN_SHAPES_PER_ACCENT = 20;
export const MAX_SHAPES_PER_ACCENT = 100;
// shape positioning
export const SHAPE_POS_RAND_RADIUS_MIN = .05;
export const SHAPE_POS_RAND_RADIUS_MAX = .3;
// shape position wandering
export const SHAPE_POS_WANDER_MIN = .05;
export const SHAPE_POS_WANDER_MAX = 1.5;
// shape angle wandering & random factor
export const SHAPE_ANGLE_RANDOM_F_MIN = 0;
export const SHAPE_ANGLE_RANDOM_F_MAX = .4;
export const SHAPE_ANGLE_WANDER_MIN = 0;
export const SHAPE_ANGLE_WANDER_MAX = .5;
// line props
export const LINE_COLOR = 0xE2DAB6;
export const LINE_WIDTH_MIN = 2;
export const LINE_WIDTH_MAX = 5;
export const LINE_WIDTH_POINTS_MIN = 6;
export const LINE_WIDTH_POINTS_MAX = 20;
// animation show / hide
export const ANIM_TIME_SHOW_MIN = 1;
export const ANIM_TIME_SHOW_MAX = 10;
export const ANIM_TIME_HIDE_MIN = 1;
export const ANIM_TIME_HIDE_MAX = 10;